export const resetSorting = (set) => () => {
  set({
    page: 1,
    sortingField: "name",
    sortingOrder: false,
    searchField: "",
  });
};
